import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import vw, { vwDesktop } from 'src/styles/utils';
import media from 'src/styles/media';

function Card(props) {
  const { title, content, backgroundColor, imageSrc, isReverseOrederDesktop,caption,backgroundPosition } = props;


  return (
    <Root bgColor={backgroundColor} isReverseOrederDesktop={isReverseOrederDesktop}>
      <ImgBox backgroundImg={imageSrc} backgroundPosition={backgroundPosition} isReverseOrederDesktop={isReverseOrederDesktop}>
      {/* <img src={imageSrc} alt={imageSrc} /> */}
      <p>{caption}</p>
      </ImgBox>
      
      <Content isReverseOrederDesktop={isReverseOrederDesktop}>
        <h6>{title}</h6>
        <p>{content}</p>
      </Content>
    </Root>
  )
}

Card.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  content: PropTypes.string,
  backgroundColor: PropTypes.string,
  isReverseOrederDesktop: PropTypes.bool,
  caption: PropTypes.string,
  backgroundPosition: PropTypes.string
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.bgColor};

  @media ${media.desktop} {
    flex-direction: ${props => props.isReverseOrederDesktop ? 'row-reverse' : 'row'};
  }

 
  /* img {
    width: 100%;
    height: auto;

    @media ${media.desktop} {
      width: 50%;
      height: 100%;
      max-width: ${vwDesktop(720)};
    }
  } */
`;

const ImgBox = styled.div`
  width: 100%;

  height: auto;
  ${vw('min-height', 200, 500, 500)};
  background-image: url(${props => props.backgroundImg});
  background-size: cover;
  /* background-position: center center; */
  background-position:  ${props => props.backgroundPosition === '' ? '' : props.backgroundPosition};
  position: relative;
 
  @media ${media.desktop} {
    width: 50%;
    max-width: ${vwDesktop(720)};
  }
  p{
    position: absolute;
    font-family: Big Caslon;
    bottom:0;
    width:100%;
    text-align: left;
    color: #FFFFFF;
    text-transform: capitalize;
    text-shadow: 0 0 4px rgba(0,0,0,.9);
    ${vw('padding-bottom', 10, 10, 10)}
    ${props => props.isReverseOrederDesktop ? vw('padding-right', 25, 60, 100) : vw('padding-right', 25, 60, 80)}
    ${props => props.isReverseOrederDesktop ? vw('padding-left', 25, 60, 80) : vw('padding-left', 25, 60, 100)}
  }
` 


const Content = styled.div`
  width: 100%;
  ${vw('padding-top', 34, 52, 60)}
  ${vw('padding-bottom', 78, 52, 60)}
  ${props => props.isReverseOrederDesktop ? vw('padding-right', 25, 60, 80) : vw('padding-right', 25, 60, 100)}
  ${props => props.isReverseOrederDesktop ? vw('padding-left', 25, 60, 100) : vw('padding-left', 25, 60, 80)}

  @media ${media.desktop} {
    width: 50%;
    max-width: ${vwDesktop(720)};
  }

  > h6 {
    font-family: Gotham Bold;
    font-style: normal;
    font-weight: bold;
    text-transform: uppercase;
    color: #000000;
    ${vw('font-size', 15, 28)}
    ${vw('line-height', 21, 35)}
    ${vw('letter-spacing', 0.36, 0.72)}
    ${vw('margin-bottom', 10, 20)}
  }

  > p {
    font-family: Big Caslon;
    font-style: normal;
    font-weight: normal;
    color: #000000;
    ${vw('font-size', 13, 16)}
    ${vw('line-height', 20, 32)}
  }
`;

export default Card
